/**
 * Load URL using fetch (browser environment)
 * @param path - URL or path to the file
 * @param _mime - MIME type (unused in browser, fetch determines it)
 * @returns Response for streaming instantiation
 */
export const UrlLoad = (
  path: string,
  _mime: string = "application/octet-stream"
): Promise<Response> => fetch(path, { cache: "force-cache" })
